<template>
  <v-dialog v-model="dialog" max-width="600px">
    <v-card>
      <v-card-title>
        <span class="headline">创建新职位</span>
      </v-card-title>
      <v-card-text>
        <v-container>
          <v-row>
            <v-col cols="12" sm="6" md="4">
              <v-autocomplete
                label="公司名称"
                v-model="job.company"
                :items="companies"
                item-text="name"
                item-value="id"
              ></v-autocomplete>
            </v-col>

            <v-col cols="12" sm="6" md="4">
              <v-text-field label="岗位名称" v-model="job.title"></v-text-field>
            </v-col>

            <v-col cols="12" sm="6" md="4">
              <v-autocomplete
                label="招聘类型"
                v-model="job.category"
              ></v-autocomplete>
            </v-col>

            <v-col cols="12" sm="6" md="4">
              <v-text-field
                label="招聘渠道"
                v-model="job.hiringNumber"
              ></v-text-field>
            </v-col>

            <v-col cols="12" sm="6" md="4">
              <v-text-field
                label="工作地点"
                v-model="job.location"
              ></v-text-field>
            </v-col>

            <v-col cols="12" sm="6" md="4">
              <v-text-field
                label="招聘对象"
                v-model="job.hiringNumber"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="4">
              <v-text-field
                label="投递链接"
                v-model="job.submissionLink"
              ></v-text-field>
            </v-col>

            <v-col cols="12" sm="6" md="12">
              <v-textarea
                label="职位描述"
                v-model="job.description"
              ></v-textarea>
              <v-col cols="12" sm="6" md="4">
                <v-text-field
                  label="备注"
                  v-model="job.submissionLink"
                ></v-text-field>
              </v-col>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="blue darken-1" text @click="dialog = false">取消</v-btn>
        <v-btn color="blue darken-1" text @click="createJob">创建</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  data() {
    return {
      dialog: false,
      companies: [
        { id: "1", name: "one" },
        { id: "2", name: "two" },
        { id: "3", name: "three" },
      ],
      job: {
        company: "",
        title: "",
        category: "",
        location: "",
        salaryRange: "",
        hiringNumber: "",
        description: "",
      },
    };
  },
  methods: {
    createJob() {
      // Implement the logic to create a new job here.
      console.log("Creating new job:", this.job);
      this.dialog = false;
    },
  },
};
</script>